import { fixNaN } from './fixNaN'

export const centsToReal = (cents) => {
  return fixNaN(cents / 100)
}
